import logger, { getLogger } from './logger';
import getCorrelationId from './getCorrelationId';

export default logger;
export { getLogger, getCorrelationId };
